<div class="form-container" [formGroup]="registrationForm">
  <app-dropdown
    [options]="serviceProviderTypes"
    label="Service Provider Type"
    formControlName="type"
    ngDefaultControl
  ></app-dropdown>

  <div class="flex gap-4">
    <app-floating-input
      class="min-w-0 flex-1"
      [autoComplete]="false"
      label="Company name"
      placeholder="Company name"
      formControlName="company_name"
      ngDefaultControl
    >
    </app-floating-input>
    <app-floating-input
      class="min-w-0 flex-1"
      [autoComplete]="false"
      label="License Number"
      placeholder="License Number"
      formControlName="license"
      ngDefaultControl
    >
    </app-floating-input>
  </div>

  <div class="flex gap-4">
    <app-floating-input
      class="min-w-0 flex-1"
      [autoComplete]="false"
      label="First name"
      placeholder="First name"
      formControlName="first_name"
      ngDefaultControl
    >
    </app-floating-input>

    <app-floating-input
      class="min-w-0 flex-1"
      [autoComplete]="false"
      label="Last name"
      placeholder="Last name"
      formControlName="last_name"
      ngDefaultControl
    >
    </app-floating-input>
  </div>

  <div class="flex gap-4">
    <app-floating-input
      class="min-w-0 flex-1"
      [autoComplete]="false"
      label="Email"
      placeholder="Email"
      formControlName="email"
      ngDefaultControl
    >
    </app-floating-input>
    <app-floating-input
      class="min-w-0 flex-1"
      [autoComplete]="false"
      label="Phone"
      placeholder="Phone"
      formControlName="phone"
      type="tel"
      ngDefaultControl
    >
    </app-floating-input>
  </div>

  <app-floating-input
    [autoComplete]="false"
    type="password"
    label="Password"
    placeholder="Password"
    formControlName="password"
    ngDefaultControl
  >
  </app-floating-input>
  <app-floating-input
    type="password"
    label="Re-Enter Password"
    placeholder="Re-Enter Password"
    formControlName="password_confirmation"
    ngDefaultControl
  >
  </app-floating-input>
</div>
